import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Service } from './../../shared/service';
import { SignIn } from './auth';
import { map, tap } from 'rxjs/operators';
import { isNullOrUndefined } from 'src/app/shared/util';
import { AlertService } from 'src/app/admin/component/notification/alert/alert.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService extends Service {

    Info;

    constructor(
        protected _client: HttpClient,
        protected _alertservice: AlertService
    ) {
        super("", "", _client, _alertservice);
    }

    signin(signin: SignIn) {
        return this.post('auth/signin', signin).
            pipe(tap((data) => {
                if (data && data["accessToken"]) {
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    if (isNullOrUndefined(this.FirstLoad))
                        this.FirstLoad = "true"
                }
                return data;
            }, (error) => console.log(error)));
    }

    signout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.FirstLoad = "true";
    }

    getSiteName() {
        console.log("SiteName");

        return this.get('auth/site_name', null);
    }

    getToken() {
        if (isNullOrUndefined(localStorage.getItem('currentUser')))
            return "";
        return JSON.parse(localStorage.getItem('currentUser')).accessToken;
    }
    getUserInfo() {
        if (isNullOrUndefined(localStorage.getItem('currentUser')))
            return "";
        return JSON.parse(localStorage.getItem('currentUser')).info;

    }

    hasToken() {
        if (this.getToken() === "")
            return false;
        return true;
    }

    set FirstLoad(_vl: any) {
        localStorage.setItem('firstLoad', _vl);
    }
    get FirstLoad() {
        return localStorage.getItem('firstLoad');
    }
}
